export default "__VITE_ASSET__CHpuJ11___"